/* eslint react/no-danger: [0] */
const React = require('react')
const PropTypes = require('prop-types')
const log = require('log').create('react', 'background_gradient_style') // eslint-disable-line

class BackgroundGradientStyle extends React.Component {

    getAdjustedColor(color, luminance) {
        let hex = color
        let lum = luminance

        // validate hex string
        hex = String(hex).replace(/[^0-9a-f]/gi, '')
        if (hex.length < 6) {
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]
        }
        lum = lum || 0

        // convert to decimal and change luminosity
        let new_hex = ''
        let c
        let i
        for (i = 0; i < 3; i++) {
            c = parseInt(hex.substr(i * 2, 2), 16)
            c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16)
            new_hex += (`00${c}`).substr(c.length)
        }

        return new_hex
    }

    getStyles() {
        const { color, luminance, nested } = this.props
        const { profile_id } = this.context

        let selector
        let attachment = ''
        if (nested) {
            // if nested, apply background-color to the profile node
            selector = `.profile.${profile_id}`
        } else {
            // if not nested, apply background-color to the body
            selector = 'body'
            attachment = ' fixed'
        }

        const adjustment_amount = luminance === 'dark' ? 0.7 : -0.1
        const adjusted_color = this.getAdjustedColor(color, adjustment_amount)
        const color_gradient = `#${color} 0%, #${color} 30%, #${adjusted_color} 100%`

        const style = `
            ${selector} {
                background-color: #${color};
                background: -webkit-linear-gradient(315deg, ${color_gradient})${attachment};
                background: linear-gradient(135deg, ${color_gradient})${attachment};
            }
        `
        return {
            __html: style.replace(/\s\s+/g, ''),
        }

    }

    render() {
        const styles = this.getStyles()

        return (
            <style dangerouslySetInnerHTML={styles}></style>
        )
    }

}

BackgroundGradientStyle.propTypes = {
    color: PropTypes.string.isRequired,
    luminance: PropTypes.string.isRequired,
    nested: PropTypes.bool,
}

BackgroundGradientStyle.contextTypes = {
    profile_id: PropTypes.string,
}

BackgroundGradientStyle.defaultProps = {
    nested: false,
}

module.exports = BackgroundGradientStyle
